import { SvgXml } from 'react-native-svg'
import { source } from './amount-equal-source'

export function AppIconAmountEqual({ size = 20 }: { size?: number; color?: string }) {
  return <SvgXml xml={source} width={size} height={size} />
}
